import React from "react";
import { Outlet } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

const PrivateRoutes = () => {
  const { instance } = useMsal();
  const isAuthenticated = () => {
    return localStorage.getItem("isLoggedIn") ? true : false;
  };
  if(isAuthenticated()){
      return <Outlet />
  }else{
    const loginRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], 
    };
    instance.loginRedirect(loginRequest) 
      .catch(e => {
        console.error(e);
      });
  }
};

export default PrivateRoutes;
